import { getJsonField } from '@/utilities/object';
import type { CompanySummary } from './useFetchCompanySummary';
import { isNumber, isString } from 'lodash';

export function getSnowflakeScoresAverage(
  score: Record<string, number> | null | undefined
) {
  if (score === null || score === undefined) return 0;
  const values = Object.values(score);
  const total = values.reduce((sum, value) => sum + value, 0);
  return Math.round(total / values.length);
}

export function getInfoFields(
  info: CompanySummary['Company']['data']['info'] | undefined
) {
  const name = getJsonField<string>(info, 'name', isString);
  const shortName = getJsonField<string>(info, 'short_name', isString);
  const yearFunded = getJsonField<number>(info, 'year_founded', isNumber);
  const url = getJsonField<string>(info, 'url', isString);
  const exchangeSymbol = getJsonField<string>(
    info,
    'exchange_symbol',
    isString
  );
  const tickerSymbol = getJsonField<string>(info, 'ticker_symbol', isString);
  const uniqueSymbol = getJsonField<string>(info, 'unique_symbol', isString);
  const address = getJsonField<string>(info, 'address', isString);
  const address2 = getJsonField<string>(info, 'address2', isString);
  const city = getJsonField<string>(info, 'city', isString);
  const state = getJsonField<string>(info, 'state', isString);
  const country = getJsonField<string>(info, 'country', isString);

  return {
    name,
    shortName,
    yearFunded,
    url,
    exchangeSymbol,
    tickerSymbol,
    uniqueSymbol,
    address,
    address2,
    city,
    state,
    country,
  };
}
